import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbActiveModal, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { NgbdSortableHeader, SortEvent } from '../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import { ApplicationSource } from '../../business-entities/application-source';
import { CityModel, CustomerDetailsViewModel, CustomerDiscount } from '../../business-entities/customer-view.model';
import { DMSSyncFailedLogRequestModel } from '../../business-entities/dmssyncfailedlog-request-model';
import { Filter } from '../../business-entities/Filter';
import { PagerData } from '../../business-entities/PagerData';
import { DeleteAdvanceSearchFilterModel, SaveAdvanceSearchFilterModel, SearchArrayModel } from '../../business-entities/save-advance-search-filter';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { AdvanceSearchService } from '../../business-services/advance-search.service';
import { ApplicationSourceService } from '../../business-services/application-source.service';
import { CustomerService } from '../../business-services/customer.service';
import { DashboardService } from '../../business-services/dashboard.service';
import { DMSSyncFailedlogService } from '../../business-services/dms-sync-failed-log.service';
import { SavedSearchComponent } from '../../components/saved-search/saved-search.component';
import { PaginationService } from '../../services/pagination.service';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { FeatureCode } from './../../../../../Autofacets-Core/src/app/utils/enums';
import { ViewCustomerComponent } from './view-customer/view-customer.component';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { UserDealersModel } from '../../business-entities/dealer-details.model';
import { DealerServiceBusinessService } from '../../business-services/dealer-service.service';
import { CustomerSendNotificationComponent } from './view-customer/customer-send-notification/customer-send-notification.component';
import { CustomerDealerAssociationComponent } from './view-customer/customer-dealer-association/customer-dealer-association.component';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css']
})
export class CustomerComponent implements OnInit, OnDestroy {
  isAdvanceSearch: any;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  customerSub: Subscription;
  customerPDFSub: Subscription;
  closeResult: string;
  closeModel : any;
  customerListExcel: CustomerDetailsViewModel[];
  customerList: CustomerDetailsViewModel[] = [];
  customerListPDF: CustomerDetailsViewModel[];
  customerDiscount: CustomerDiscount = {
    id: 0,
    comment: '',
    discount: 0
  }
  userRoleRightsDetails: UserRoleMenu;
  isView: boolean = false;

  pager: any = {};
  totalCount: number = 0;
  pagerData: PagerData = {
    page: 1,
    pagerSize: 25//Constant.GridPagerSize
  }
  dataRows: any[] = [];
  filter: Filter = new Filter();
  filterItems: any[];
  pagedItems: any[];
  searchTerm: string;
  popupCloseResult = false;
  dealerList: Array<SelectListItemViewModel>;
  selectedDealerId: string = '';
  customerGroupList: any;
  addressSalutationList: any;
  applicationSourceList: Array<SelectListItemViewModel>;
  postCodeList: any;
  postCodeRawData: any;
  cityList: CityModel[];
  selectedItems = [];
  companyShow: boolean = false;
  saveSearchFilter: SaveAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.Customer,
    saveSearchArray: []
  };
  deleteSearchFilter: DeleteAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.Customer,
  };
  dropdownSettings = {};
  savedSearchListResponse: SaveAdvanceSearchFilterModel[] = [];
  integrationWithDMS: boolean = false;
  control = new FormControl();
  SyncList: StatusViewModel[] = [];
  StatusList: StatusViewModel[] = [];
  selectedStatus: number;
  selectedSync: number;
  IsDMS: boolean;
  subscription : Subscription;
  dmsLogRequestModel: DMSSyncFailedLogRequestModel =
    {
      startRecordNumber: 0,
      pageSize: 25,
      sortColumn: '',
      sortDirection: '',
      moduleId: Enums.ModuleNames.Customer,
      logDate: '',
      referenceId: 0
    };
    allowCompanyCreation:boolean;
    allowAccount:boolean;
    allowQuickSearch:boolean;
    debounceTimer;
    CustomerManualNotify:boolean = false
  @ViewChild('htmlData1') htmlData: ElementRef;

  @Input() fromVehicleScreen: any = false;
  @Input() customerNo: any;
  @Input() searchThroughLocalDF: any = false;
  selectedCustomerId: any = null;

  throttle = 100;
  scrollDistance = 1;
  hideAddCustomer = false;
  showAssociatedDealers = false;
  isMG = false;
  _clientName: string;

  constructor(
    private router: Router,
    private service: CustomerService,
    private advanceSearchService: AdvanceSearchService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private userService: UserDataService,
    public dealerBusinessService: DealerBusinessService,
    private excelService: ExcelService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private pagerService: PaginationService,
    private cdr: ChangeDetectorRef,
    private currentLanguageService: CurrentLanguage,
    private dashboardService: DashboardService,
    private applicationSourceService: ApplicationSourceService,
    private activeModal: NgbActiveModal,
    private dmsService: DMSSyncFailedlogService,
    private dealerServiceBusinessService: DealerServiceBusinessService,
    private secureStorage: SecureStorage,
    private _eref: ElementRef,
    private toaster: ToastrService,
    config: NgbModalConfig
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  resetVariables() {
    this.companyShow = false;
    this.service.customerListRequest.customerTypeId = 0;
    this.service.customerListRequest.firstName = '';
    this.service.customerListRequest.lastName = '';
    this.service.customerListRequest.customerName = '';
    this.service.customerListRequest.customerNo = '';
    this.service.customerListRequest.customerGroup = null;
    this.service.customerListRequest.salutation = null;
    this.service.customerListRequest.postCode = null;
    this.service.customerListRequest.city = null;
    this.service.customerListRequest.email = '';
    this.service.customerListRequest.mobile = '';
    this.service.customerListRequest.licensePlateNo = '';
    this.service.customerListRequest.sourceOfCreation = '';
    this.service.customerListRequest.dealerName = '';
    this.selectedDealerId = null;
    this.service.customerListRequest.dealerId = null;
    this.selectedItems = [];
    this.service.customerListRequest.startRecordNumber = 0;
    this.customerList = []
  }
  onReset() {
    this.resetVariables();
    this.getCustomerList();
  }
  onClose() {
    this.isAdvanceSearch = false;
  }
  onSearch() {
    if (this.customerGroupList == undefined) {
      this.getCustomerGroup();
    }
    if (this.postCodeRawData == undefined) {
      this.getPostCodeDropdown();
    }
    if (this.applicationSourceList == undefined) {
      this.GetApplicationSource();
    }
    this.cdr.detectChanges();
    this.isAdvanceSearch = true;
    this.cdr.detectChanges();
  }

  onApplyFilter() {
    this.AdvanceSearchSubmit();

  }

  AdvanceSearchSubmit() {

    this.service.customerListRequest.sourceOfCreation = "";
    if (this.selectedItems.length > 0) {
      this.service.customerListRequest.sourceOfCreation = this.selectedItems.map(x => x.value).join(',')
    }
    this.service.customerListRequest.searchTerm = this.searchTerm;
    this.service.customerListRequest.customerTypeId = this.companyShow ? 2 : 1;
    this.service.customerListRequest.dealerId = this.selectedDealerId;
    this.service.customerListRequest.startRecordNumber = Constant.startRecordNumber;
    this.customerList = []
    this.getCustomerList();
    this.isAdvanceSearch = false;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.service.customerListRequest.sortColumn = column;
    this.service.customerListRequest.sortDirection = direction;
    this.service.customerListRequest.startRecordNumber = 0;
    this.customerList = []
    this.getCustomerList();
  }
  onEnterPress(){
    this.debounceFunction(()=>this.onSearchFilter(),500);
  }

  debounceFunction(func,delay){
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }
  onSearchFilter() {
    this.service.customerListRequest.startRecordNumber = 0;
    this.service.customerListRequest.searchTerm = this.searchTerm;
    this.customerList = []
    this.getCustomerList();
  }

  onRefresh() {
    this.service.customerListRequest.startRecordNumber = 0;
    this.customerList = []
    this.getCustomerList();
  }
  ngOnInit(): void {
    this._clientName = localStorage.getItem("Theme");
    this.hideAddCustomer = this.showAssociatedDealers = this.isMG = localStorage.getItem("Theme") === 'mg';
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      searchPlaceholderText: 'Search here',
      maxHeight: 500
    };
    if (this.dashboardService.isFromDashboard || this.fromVehicleScreen) {
      this.selectedStatus = Enums.StatusCode.Active;
    }
    if (this.selectedStatus != undefined) {
      this.service.customerListRequest.statusId = this.selectedStatus;
    }

    if (this.dashboardService.isFromDashboard) {
      this.selectedSync = Enums.DmsSync.Success;
    }
    if (this.selectedSync != undefined) {
      this.service.customerListRequest.syncId = this.selectedSync;
    }

    if(this.fromVehicleScreen){
      this.service.customerListRequest.searchTerm = this.customerNo;
      this.service.customerListRequest.statusId = Constant.ActiveCustomer;
      this.searchTerm = this.customerNo;
    }

    this.StatusList = this.dashboardService.getStatusList();
    this.SyncList = this.dashboardService.getDmsStatusList();
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Customer);
    this.service.customerListRequest.startRecordNumber = 0;
    this.customerList = []
    this.getFeatures();
    this.getUserDealers();
  }

  async GetApplicationSource(): Promise<void> {
    await this.applicationSourceService.getApplicationSource().then(data => {
      this.applicationSourceList = this.mapdealer(data.responseObject).filter(source => source.value === Enums.SourceId.Planner || source.value === (this.isMG ? Enums.SourceId.CRM : Enums.SourceId.DMS) );
    });
  }


  mapdealer(array: ApplicationSource[]) {
    let supperArray = [];
    if (array && array.length > 0) {

        array.forEach(element=>{
      let single = Object();
        single.value = element.sourceId
        single.text = element.sourceName

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  async getFeatures() {
    let features = this.secureStorage.getKeyData('feature');
    if(features == null || features == undefined){
      this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
        features = res;
        if (features?.length > 0) {
          this.getCustomers(features);
        }
      })
    }
    else{
      this.getCustomers(features);
    }
  }
  getCustomers(features:any){
          this.integrationWithDMS = this._clientName === 'mg' ? features.find(x => x.featureCode === Enums.FeatureCode.CRM)?.isActive : 
          features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
          this.allowCompanyCreation = features.find(x => x.featureCode === FeatureCode.AllowCompanyCreation)?.isActive;
          this.allowAccount = features.find(x => x.featureCode === FeatureCode.AllowAccount)?.isActive;
          this.allowQuickSearch = features.find(x => x.featureCode === FeatureCode.AllowQuicksearch)?.isActive;
          this.IsDMS = this._clientName === 'mg' ? features.find(x => x.featureCode === Enums.FeatureCode.CRM)?.isActive : 
          features.find(x => x.featureCode === FeatureCode.DMS)?.isActive;
          this.CustomerManualNotify = features.find(x => x.featureCode === FeatureCode.CustomerManualNotify)?.isActive
          this.getCustomerList();
  }
  async getCustomerGroup() {
    this.spinner.show();
    await this.service.GetCustomerGroupDropdown().then((response) => {
        this.customerGroupList = response.responseObject.filter(x => x.isDisplay);
        this.customerGroupList = this.customerGroupList.sort((a, b) =>
          (b?.code || '').localeCompare(a?.code || '')
        );
      this.spinner.hide();
    }, _error => {
      this.spinner.hide()
    });

  }

  async getAddressSalutationDropdown() {
    this.spinner.show();
    await this.service.GetAddressSalutationDropdown().then((response) => {
      this.addressSalutationList = response != null ? response.responseObject : [];
      this.spinner.hide();
    }, _error => {
      this.spinner.hide()
    });
  }

  async getPostCodeDropdown() {
    this.spinner.show();
    let postCodes = this.secureStorage.getKeyData('postCodes');
    if (postCodes) {
      this.postCodeRawData = postCodes;
      this.BindPostData("");
      this.BindCityData("");
    } 
    this.spinner.hide();
  }

  BindPostData(city) {
    if (city?.trim()) {
      this.postCodeList = this.postCodeRawData.filter(f => f.city == city);
    } else {
      this.postCodeList = this.postCodeRawData;
    }
  }

  BindCityData(post) {
    if (post?.trim()) {
      let postdata = this.postCodeRawData.filter(f => f.code == post);
      this.cityList = postdata.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.onCitySelected(this.cityList[0])
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
    }
  }

  async onPostCodeSelected(postCode: string) {
    this.service.customerListRequest.postCode = postCode;
    if (postCode?.trim()) {
      this.BindCityData(postCode);
    } else {
      this.postCodeList = this.postCodeRawData;
      this.service.customerListRequest.city = "";
    }
  }

  async onCitySelected(city: any) {
    this.service.customerListRequest.city = city;
    if (city?.trim()) {
      this.BindPostData(city);
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.service.customerListRequest.postCode = "";
    }
  }

  changeCustomerType(event: Event) {
    this.companyShow = (event.target as HTMLInputElement).checked;
  }

  public async openPDF(): Promise<void> {
    this.spinner.show();
    this.service.customerListRequest.isForDocuments = true;
    await this.service.getCustomerList(this.service.customerListRequest).then((response) => {
      this.spinner.hide();
      this.cdr.detectChanges();
      this.customerListPDF = this.customerDataMapper(response.responseObject.customerList);
      this.cdr.detectChanges();

    }, _error => {
      this.spinner.hide()
    });
    this.service.customerListRequest.isForDocuments = false;
    const doc = new jsPDF();
    autoTable(doc, { html: '#customerPDF', margin: { top: 3, left: 3, right: 3, bottom: 3 }, styles: { fontSize: 8 } });
    doc.save('Customer-List.pdf');

    this.spinner.hide();
  }
  async exportAsXLSX(): Promise<void> {
    this.spinner.show();
    this.service.customerListRequest.isForDocuments = true;
    await this.service.getCustomerList(this.service.customerListRequest).then((response) => {
      this.spinner.hide();
      this.cdr.detectChanges();
      this.customerListExcel = this.customerExcelDataMapper(response.responseObject.customerList);
      this.cdr.detectChanges();
    }, _error => {
      this.spinner.hide()
    });
    this.service.customerListRequest.isForDocuments = false;
    this.spinner.hide();

    this.excelService.exportAsExcelFile(this.customerListExcel, 'customers_af');
  }

  StatusChange(status: any) {
    if (status == undefined) {
      this.service.customerListRequest.statusId = Enums.StatusCode.All;
    } else {
      this.service.customerListRequest.statusId = status;
    }
    this.service.customerListRequest.startRecordNumber = 0;
    this.customerList = [];
    this.getCustomerList();
  }

  SyncChange(status: any) {
    if (status == undefined) {
      this.service.customerListRequest.syncId = Enums.DmsSync.All;
    } else {
      this.service.customerListRequest.syncId = status;
    }
    this.service.customerListRequest.startRecordNumber = 0;
    this.customerList = [];
    this.getCustomerList();
  }

  onScrollDown(_ev) {
    if(this.totalCount > this.customerList.length){
      this.service.customerListRequest.startRecordNumber = this.customerList.length;
      this.getCustomerList();
    }
  }

  async getCustomerList() {
    this.spinner.show();
    await this.service.getCustomerList(this.service.customerListRequest).then((response) => {
      this.spinner.hide();
      this.customerList.push(...this.customerDataMapper(response.responseObject.customerList));
      if (response.responseObject?.result?.errorCode == "5449") {
        this.totalCount = 0;
      }
      else {
        this.totalCount = this.customerList.length > 0 ? this.customerList[0].totalCount : 0;
      }
      if(this.customerList.length == 1 && this.searchThroughLocalDF){
        this.selectedCustomerId = this.customerList[0].id
        this.selectedCustomer();
      }
      this.resetPagerData(this.supplierInitiliseGridFromServer(this.customerList, this.totalCount));
      if (this.pagerData.page > 1) {
        this.resetPagerData(this.initilisePagerFromServer(this.pagerData.page, this.pagerData.pagerSize, this.totalCount));
      }

    }, _error => {
      this.spinner.hide()
    });
  }

  private customerDataMapper(customer: any) {
    let supperArray = [];
    if (customer && customer.length > 0) {

      for (let index = 0; index < customer.length; index++) {
        const element = customer[index];

        let single = Object();
        single.rowNumber = (this.service.customerListRequest.startRecordNumber + 1) + index;
        single.id = element.id
        single.customerId = element.customerId
        single.customerName = element.customerName
        single.addressLine1 = element.addressLine1
        single.addressLine2 = element.addressLine2
        single.city = element.city
        single.state = element.state
        single.country = element.country
        single.email = element.email
        single.mobileNo = element.mobileNo
        single.mobileCode = element.mobileCode
        single.discount = element.discount
        single.comment = element.comment
        single.noOfVehicle = element.noOfVehicle
        single.customerType = element.customerType
        single.firstName = element.firstName
        single.lastName = element.lastName
        single.sourceType = element.sourceType
        single.isActive = element.isActive
        single.activeStatus = element.activeStatus
        single.customerNo = element.customerNo
        single.pincode = element.pincode
        single.dmsSyncStatus = element.dmsSyncStatus
        single.updatedDate = element.updatedDate ? new Date(element.updatedDate + 'Z') : null;
        single.dmsSyncDate = element.dmsSyncDate ? new Date(element.dmsSyncDate + 'Z') : null;
        single.createdDate = element.createdDate ? new Date(element.createdDate + 'Z') : null;
        single.totalCount = element.totalCount
        single.preferredDealerName = element.preferredDealerName
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  async setPage(pagerData: PagerData) {
    if (pagerData == null || pagerData === undefined || pagerData.page < 1 || pagerData.page > this.pager.totalPages) {
      return;
    }
    this.pagerData.page = pagerData.page;
    this.pagerData.pagerSize = pagerData.pagerSize;
    this.service.customerListRequest.startRecordNumber = (pagerData.pagerSize * (pagerData.page - 1));
    this.service.customerListRequest.pageSize = pagerData.pagerSize;
    await this.getCustomerList();
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = (data.length === 0) ? 0 : 1;
    return this.initilisePagerFromServer(this.filter.page, Number(this.filter.pageSize), count);
  }

  initilisePagerFromServer(page: number, _pageSize: number, count: number = this.filterItems.length) {
    let length = this.filterItems.length <= Constant.GridPagerSize ? Constant.GridPagerSize : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems; // .slice(this.pager.startIndex, this.pager.endIndex + 1);
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  private customerExcelDataMapper(customer: any) {
    let supperArray = [];
    if (customer && customer.length > 0) {

      for (let index = 0; index < customer.length; index++) {
        const element = customer[index];

        let single = Object();
        single.No = (this.service.customerListRequest.startRecordNumber + 1) + index;
        single.CustomerNo = element.customerNo
        single.CustomerName = element.customerName
        single.CustomerType = element.customerType
        single.Address = element.addressLine1 + element.addressLine2
        single.City = element.city
        single.Country = element.country
        single.Email = element.email
        single.Mobile = element.mobileNo
        single.NoOfVehicles = element.noOfVehicle
        single.SourceType = element.sourceType
        single.ActiveStatus = element.activeStatus
        // single.Discount = element.discount
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  open(content, id) {
    let record = this.customerList.find(x => x.id === id);
    this.customerDiscount.id = id
    this.customerDiscount.comment = record.comment
    this.customerDiscount.discount = record.discount
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  
  async viewAssociatedDealers(item: any) { 
    this.spinner.show();
    await this.service
      .getCustomerDealerAssociationById(item.id)
      .then((response) => {
        if (response.responseCode === Constant.SuccessResponseCode) {
          this.OpenCustomerDealerAssociationModel(response.responseObject, item);
        } else {
            this.toaster.error(Enums.ToastrMessages.CustomerDealerAssociationNotFound);
        }
        this.spinner.hide();
      })
      .catch(() => {
        this.spinner.hide();
      });
  }

  onEdit(id: number) {
    this.service.customerId = id;
    if (id > 0) {
      let record = this.customerList.find(x => x.id === id);
      this.service.customerNo = record.customerNo;
      this.service.customerName = record.customerName;
      this.service.customerMobileNo = record.mobileNo;
      this.service.customerDetail = record;
      this.service.firstName = record.firstName;
      this.service.lastName = record.lastName;
      this.service.contactId = record.customerId;
    } else {
      this.service.customerNo = "";
      this.service.customerName = "";
      this.service.customerMobileNo = "";
      this.service.customerDetail = null;
      this.service.firstName="";
      this.service.lastName=""
    }

    const modalref = this.modalService.open(ViewCustomerComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.componentInstance.isFromServiceAdvisor = false;
    modalref.componentInstance.fromVehicleScreen = this.fromVehicleScreen;
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    }, _error => {
      // This is intentional
     });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  ngOnDestroy(): void {
    if (this.customerSub) {
      this.customerSub.unsubscribe();
    }
    if (this.customerPDFSub) {
      this.customerPDFSub.unsubscribe();
    }
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    this.service.customerListRequest.searchTerm = null
    this.dashboardService.isFromDashboard = false;
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  OpenSaveSearchModal(content) {
    this.saveSearchFilter.saveSearchArray = [];
    this.control = new FormControl();
    this.createSaveSearchModel();
    if (this.saveSearchFilter.saveSearchArray.length > 0) {
      this.closeModel = this.modalService.open(content, { size: 'xl', ariaLabelledBy: 'modal-basic-title' })
      this.closeModel.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    else {
      let ErrorMsg = this.translate.instant("lblPleaseFillAtleastOneField");
      this.toastr.error(ErrorMsg);
    }
  }

  createSaveSearchModel() {
    this.saveSearchFilter.filterName = null;
    this.saveSearchFilter.moduleId = Enums.ModuleNames.Customer;
    this.service.customerListRequest.customerTypeId = this.companyShow ? 2 : 1;
    this.service.customerListRequest.sourceOfCreation = "";
    if (this.selectedItems.length > 0) {
      this.service.customerListRequest.sourceOfCreation = this.selectedItems.map(x => x.value).join(',')
    }
    if (this.service.customerListRequest.customerTypeId > 0) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblCompany",
        searchValue: this.service.customerListRequest.customerTypeId == 2 ? "Company" : "Individual",
        searchActualValue: this.service.customerListRequest.customerTypeId == 2 ? "Company" : "Individual",
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }

    if (this.service.customerListRequest.customerName) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblName",
        searchValue: this.service.customerListRequest.customerName,
        searchActualValue: this.service.customerListRequest.customerName
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.customerListRequest.customerNo) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblCustomerNumber",
        searchValue: this.service.customerListRequest.customerNo,
        searchActualValue: this.service.customerListRequest.customerNo
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.customerListRequest.customerGroup) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblCustomerGroup",
        searchValue: this.service.customerListRequest.customerGroup,
        searchActualValue: this.service.customerListRequest.customerGroup
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.customerListRequest.salutation) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSalutation",
        searchValue: this.service.customerListRequest.salutation,
        searchActualValue: this.service.customerListRequest.salutation
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.customerListRequest.postCode) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblPostCode",
        searchValue: this.service.customerListRequest.postCode,
        searchActualValue: this.service.customerListRequest.postCode
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.customerListRequest.city) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblCity",
        searchValue: this.service.customerListRequest.city,
        searchActualValue: this.service.customerListRequest.city
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.customerListRequest.email) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblEmail",
        searchValue: this.service.customerListRequest.email,
        searchActualValue: this.service.customerListRequest.email
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.customerListRequest.mobile) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblMobile",
        searchValue: this.service.customerListRequest.mobile,
        searchActualValue: this.service.customerListRequest.mobile
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.service.customerListRequest.licensePlateNo) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblLicensePlate",
        searchValue: this.service.customerListRequest.licensePlateNo,
        searchActualValue: this.service.customerListRequest.licensePlateNo
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }

    if (this.service.customerListRequest.sourceOfCreation) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSource",
        searchValue: this.selectedItems.map(x => x.text).join(','),
        searchActualValue: this.selectedItems.map(x => x.text).join(',')
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }

    if (this.service.customerListRequest.dealerName) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblDealersName",
        searchValue: this.service.customerListRequest.dealerName,
        searchActualValue: this.service.customerListRequest.dealerName
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }

  }

  SaveAdvanceSearchFilter() {
    if (!this.saveSearchFilter.filterName.replace(/\s/g, "").length) {
      let errorMsg = this.translate.instant("lblSearchNameRequired");
      this.toastr.error(errorMsg);
      return;
    }
    this.advanceSearchService.SaveAdvanceSearchFilter(this.saveSearchFilter).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
        let successMsg = this.translate.instant("lblSearchFilteredSaved");
        this.toastr.success(successMsg);
       this.closeModel.close();
      }
      else {
        let errorMsg = this.translate.instant("lblSaveSearchFilterNameAlreadyExists");
        this.toastr.error(errorMsg);
      }
    });
  }

  OpenSavedSearchListPopup() {
    this.spinner.show();
    this.GetAdvanceSearchList().then((_res) => {
      const modalref = this.modalService.open(SavedSearchComponent, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
      });
      modalref.componentInstance.isFromAppointment = false;
      modalref.componentInstance.searchList = this.savedSearchListResponse;
      modalref.componentInstance.onReset.subscribe((_data) => {
        this.onReset();
      });
      modalref.componentInstance.onEditOrRun.subscribe((data) => {
        if (data.isRun) {
          this.resetVariables();
        }
        this.ApplySaveSearch(data.searchData, data.isRun);
      });
      modalref.componentInstance.onDelete.subscribe((data) => {
        this.OnDeleteSaveSearch(data,modalref);
      });
    });
  }
  async GetAdvanceSearchList() {
    await this.advanceSearchService.GetAdvanceSearchList(Enums.ModuleNames.Customer).then(result => {
      if (result) {
        if (result.responseObject.errorCount) {
          this.spinner.hide();
        }
        else {
          this.savedSearchListResponse = result.responseObject;
          this.savedSearchListResponse.forEach(element => {
            element.saveSearchArray.forEach(val => {
              val.searchActualValue = val.searchValue;
            });
          });
        }
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }

  OnDeleteSaveSearch(searchName,outerModalRef) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblSavedFilters"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        this.deleteSearchFilter.filterName = searchName;
        this.advanceSearchService.DeleteAdvanceSearch(this.deleteSearchFilter).then(response => {
          if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
            this.GetAdvanceSearchList().then(()=>outerModalRef.dismiss());
            let msg = this.translate.instant("lblSaveSearchDeletedSuccessfully");
            this.toastr.success(msg);
          }
          else {
            let msg = this.translate.instant("lblFailedTodeleteSaveSearch");
            this.toastr.error(msg);
          }
        }, error => {
          if (error.status === Constant.BadRequest) {
            let WarningMessage = this.translate.instant("lblErrorWarningForValue")
            this.toastr.warning(WarningMessage);
          }
          else {
            let errorMessage = this.translate.instant("lblErrorMessage");
            this.toastr.error(errorMessage);
          }

        });
      }
    });
  }

  ApplySaveSearch(data,isRunSearch) {
    if (data) {
      let saveSearchDetail = this.savedSearchListResponse.filter(x => x.filterName === data);
      if (saveSearchDetail.length > 0 && saveSearchDetail[0]) {
        saveSearchDetail[0].saveSearchArray.forEach(element => {
          switch (element.searchColumnName) {
            case 'lblCompany':
              this.service.customerListRequest.customerTypeId = element.searchValue == "Company" ? 2 : 1;
              this.companyShow = this.service.customerListRequest.customerTypeId == 2 ? true : false;
              break;
            case 'lblFirstName':
              this.service.customerListRequest.firstName = element.searchValue;
              break;
              case 'lblLastName':
                this.service.customerListRequest.lastName = element.searchValue;
              break;
              case 'lblCompanyName':
                this.service.customerListRequest.customerName = element.searchValue;
              break;
            case 'lblCustomerNumber':
              this.service.customerListRequest.customerNo = element.searchValue;
              break;
            case 'lblCustomerGroup':
              this.service.customerListRequest.customerGroup = element.searchValue;
              break;
            case 'lblSalutation':
              this.service.customerListRequest.salutation = element.searchValue;
              break;
            case 'lblPostCode':
              this.service.customerListRequest.postCode = element.searchValue;
              break;
            case 'lblCity':
              this.service.customerListRequest.city = element.searchValue;
              break;
            case 'lblEmail':
              this.service.customerListRequest.email = element.searchValue;
              break;
            case 'lblMobile':
              this.service.customerListRequest.mobile = element.searchValue;
              break;
            case 'lblLicensePlate':
              this.service.customerListRequest.licensePlateNo = element.searchValue;
              break;
            case 'lblDealersName':
            this.service.customerListRequest.dealerName = element.searchValue;
            break;
            case 'lblSource':
              let sourceStr = element.searchValue.split(",");
              if (this.applicationSourceList && sourceStr) {
                this.applicationSourceList.forEach(x => {
                  sourceStr.forEach(y => {
                    if (x.text === y) {
                      this.selectedItems.push(x);
                    }
                  })
                })
              }

              this.service.customerListRequest.sourceOfCreation = this.selectedItems.map(x => x.value).join(',');
              break;
            default:
              break;
          }
        });
      }
      if (isRunSearch) {
        this.AdvanceSearchSubmit();
      }
      else {
        this.onSearch();
        this.activeModal.dismiss();
      }
    }
  }

  onSyncToDms(id) {
    let modelHeadermsg = this.translate.instant(this.isMG ? "lblSyncToCRM" : "lblSyncToDMS");
    let modelBodymsg = this.translate.instant(this.isMG ? "lblSureToSyncCRM" : "lblSureToSync");
    let errorMsg = this.translate.instant('lblErrormsg');
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        this.service.ResyncCustomer(id, Enums.ModuleNames.Customer).then((response) => {
          this.spinner.hide();
          if (response.responseObject.isSuccess) {
            let successMsg = this.translate.instant(this.isMG ? 'lblSyncSuccessCRM' : 'lblSyncSuccess')
            this.toastr.success(successMsg);
            this.service.customerListRequest.startRecordNumber = 0;
            this.customerList = [];
            this.getCustomerList();
          } else {
            this.spinner.hide();
            this.toastr.error(errorMsg);
          }
        });
      }
    });
  }


  OnClose() {
    this.activeModal.close({ success: true });
  }
   @HostListener('document:click', ['$event'])
   onSearchBoxClose(event) {
     if (event && (event.target.className.indexOf('ng-option')==-1 && event.target.parentElement.className.indexOf('ng-option') == -1) && event.target.className.indexOf('btn')==-1) {
       if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
         this.isAdvanceSearch = false;
       }
     }
   }
  async selectedCustomer() {
    let customerDetail = null;
    this.activeModal.close({ success: true, customerId: this.selectedCustomerId });
  }

  async getUserDealers() {
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealers(response.userDealersModel);
      this.dealerBusinessService.dealerList = this.dealerList;
      if(this.dealerList.length===1)
      {
        this.selectedDealerId = response.userDealersModel[0].dealerId;
      }
    })
  }
  
  mapdealers(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element => {
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }
  viewException(id: number) {
    this.dmsLogRequestModel.referenceId = id;
    this.spinner.show();
    let errorMsg = this.translate.instant('lblNoErrorDetails');
    this.dmsService.GetDmsSyncFailedLog(this.dmsLogRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.spinner.hide();
        if (response.responseObject.length > 0) {
          let ex = response.responseObject[0].exceptionMessage;

          let modelHeadermsg = this.translate.instant("lblException");
          const modalRef = this.modalService.open(NgInfoModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = ex;
          modalRef.result.then((_result) => {
            // This is intentional
          }, (reason) => {
            this.popupCloseResult = this.getDismissDeleteReason(reason);
          });
        } else {
          this.toastr.error(errorMsg);
        }
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.MechanicCode) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }
  onDealerSelected(dealerId: string, flag: string) {
    this.selectedDealerId = dealerId;
    this.dealerServiceBusinessService.dealerId = dealerId;
    if (flag === 'dealerDropdown') {
      this.service.customerListRequest.isAdvanceSearch = false;
      this.getCustomerList();
    }
    else {
      this.service.customerListRequest.isAdvanceSearch = true;
    }
  }

  //#region Send Notification
  OpenSendNotificationModel(customer): void {
    const modalref = this.modalService.open(CustomerSendNotificationComponent, { size: 'lg', windowClass: 'pop-wid1200' });
    modalref.componentInstance.customerDetails = {
      id: customer.id,
      mobileCode: customer.mobileCode,
      mobileNo: customer.mobileNo,
      email: customer.email,
      customerNo: customer.customerNo,
      customerName: customer.customerName
    };
  }
  //#endregion

  //#region View Customer Dealer Association
  OpenCustomerDealerAssociationModel(customerDealerAssociation: any, customer: any): void {
    const modalref = this.modalService.open(CustomerDealerAssociationComponent, { size: 'lg', windowClass: 'pop-wid1200' });
    modalref.componentInstance.customerDealerAssociation = customerDealerAssociation;
    modalref.componentInstance.customerName = customer.customerName;
    modalref.componentInstance.customerNo = customer.customerNo;
  }
  //#endregion


}
